/**
 * @module ol/layer/Property
 */

/**
 * @enum {string}
 */
export default {
  OPACITY: 'opacity',
  VISIBLE: 'visible',
  EXTENT: 'extent',
  Z_INDEX: 'zIndex',
  MAX_RESOLUTION: 'maxResolution',
  MIN_RESOLUTION: 'minResolution',
  SOURCE: 'source'
};

//# sourceMappingURL=Property.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/ol/layer/Property.js
// module id = ../../../../ol/layer/Property.js
// module chunks = 3